var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c("div", { staticClass: "loading" }, [
          _c(
            "div",
            { staticClass: "md-layout md-gutter md-alignment-top-center" },
            [
              _c("md-progress-spinner", {
                attrs: {
                  "md-diameter": 50,
                  "md-stroke": 5,
                  "md-mode": "indeterminate"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.company
      ? _c(
          "div",
          { staticClass: "md-layout md-gutter md-alignment-top-center" },
          [
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-size-20 md-medium-size-10 md-small-size-10 md-xsmall-size-0"
              },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-fab",
                    on: {
                      click: function($event) {
                        return _vm.goBack()
                      }
                    }
                  },
                  [_c("md-icon", [_vm._v("arrow_back")])],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-size-60 md-medium-size-70 md-small-size-100 md-xsmall-size-100"
              },
              [
                _c(
                  "md-card",
                  [
                    _c("md-toolbar", { attrs: { "md-elevation": 1 } }, [
                      _c("span", { staticClass: "md-title" }, [
                        _vm._v(_vm._s(_vm.company.name))
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.company
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "md-layout md-gutter md-alignment-top-center"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "md-layout-item md-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100"
                              },
                              [
                                _c(
                                  "md-list",
                                  { staticClass: "md-double-line" },
                                  [
                                    _c("md-subheader", [
                                      _vm._v("Ansprechpartner")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "md-list-item",
                                      [
                                        _c(
                                          "md-icon",
                                          { staticClass: "md-primary" },
                                          [_vm._v("person")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "md-list-item-text" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.company.contact)
                                              )
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("md-subheader", [_vm._v("Adresse")]),
                                    _vm._v(" "),
                                    _c(
                                      "md-list-item",
                                      [
                                        _c(
                                          "md-icon",
                                          { staticClass: "md-primary" },
                                          [_vm._v("home")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "md-list-item-text" },
                                          [
                                            _c("span", [
                                              _vm._v(_vm._s(_vm.company.street))
                                            ]),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("span", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.company.zip.toString()
                                                  )
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(_vm.company.city))
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("md-subheader", [_vm._v("Telefon")]),
                                    _vm._v(" "),
                                    _c(
                                      "md-list-item",
                                      [
                                        _c(
                                          "md-icon",
                                          { staticClass: "md-primary" },
                                          [_vm._v("phone")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "md-list-item-text" },
                                          [
                                            _c("span", [
                                              _vm._v(_vm._s(_vm.company.phone))
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("md-subheader", [_vm._v("Email")]),
                                    _vm._v(" "),
                                    _c(
                                      "md-list-item",
                                      [
                                        _c(
                                          "md-icon",
                                          { staticClass: "md-primary" },
                                          [_vm._v("email")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "md-list-item-text" },
                                          [
                                            _c("span", [
                                              _vm._v(_vm._s(_vm.company.email))
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("md-subheader", [_vm._v("Web")]),
                                    _vm._v(" "),
                                    _c(
                                      "md-list-item",
                                      [
                                        _c(
                                          "md-icon",
                                          { staticClass: "md-primary" },
                                          [_vm._v("web")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "md-list-item-text" },
                                          [
                                            _c("span", [
                                              _vm._v(_vm._s(_vm.company.web))
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "md-layout-item md-size-40 md-medium-size-50 md-small-size-100 md-xsmall-size-100"
                              },
                              [
                                _c("md-content", [
                                  _c("h4", [
                                    _vm._v("Unternehmensbeschreibung")
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.company.description))
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _vm.company.skills
                                    ? _c("div", [
                                        _c("h4", [_vm._v("Fähigkeiten")]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(_vm._s(_vm.company.skills))
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _vm.company.interests
                                    ? _c("div", [
                                        _c("h4", [_vm._v("Interessen")]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(_vm._s(_vm.company.interests))
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _vm.company.offered.length > 0
                                    ? _c(
                                        "div",
                                        [
                                          _c("h4", [
                                            _vm._v("Bietet diese Technologien")
                                          ]),
                                          _vm._v(" "),
                                          _vm._l(_vm.company.offered, function(
                                            item
                                          ) {
                                            return _c(
                                              "div",
                                              { key: item.hash },
                                              [
                                                _c(
                                                  "router-link",
                                                  {
                                                    attrs: {
                                                      to: {
                                                        name:
                                                          "TechnologyDetail",
                                                        params: {
                                                          hash: item.hash
                                                        }
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "md-chip",
                                                      {
                                                        staticClass:
                                                          "md-primary",
                                                        staticStyle: {
                                                          margin: "2px"
                                                        },
                                                        attrs: {
                                                          "md-clickable": ""
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.name)
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }),
                                          _vm._v(" "),
                                          _vm.company.offered.length == 0
                                            ? _c("div", [
                                                _c("h5", [
                                                  _vm._v(
                                                    "Keine Technologien angegeben"
                                                  )
                                                ])
                                              ])
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.company.requested.length > 0
                                    ? _c(
                                        "div",
                                        [
                                          _c("h4", [
                                            _vm._v(
                                              "Sucht nach diesen Technologien"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.company.requested,
                                            function(item) {
                                              return _c(
                                                "div",
                                                { key: item.hash },
                                                [
                                                  _c(
                                                    "router-link",
                                                    {
                                                      attrs: {
                                                        to: {
                                                          name:
                                                            "TechnologyDetail",
                                                          params: {
                                                            hash: item.hash
                                                          }
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "md-chip",
                                                        {
                                                          staticClass:
                                                            "md-primary",
                                                          staticStyle: {
                                                            margin: "2px"
                                                          },
                                                          attrs: {
                                                            "md-clickable": ""
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.name)
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm.company.requested.length == 0
                                            ? _c("div", [
                                                _c("h5", [
                                                  _vm._v(
                                                    "Keine Technologien angegeben"
                                                  )
                                                ])
                                              ])
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                ])
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "md-layout-item md-size-20 md-medium-size-15 md-small-size-10 md-xsmall-size-0"
            })
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00e22aa1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00e22aa1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/companysearch/detail/CompanyDetail.vue
// module id = null
// module chunks = 